import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  Badge,
  CTA,
  Checkbox,
  CustomInput,
  CustomSelect,
  Modal,
  Text,
} from '../..';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import { ScrollableArea } from '../style';
import { MODAL_CLOSE } from '../../../../app/redux/actions';
import InputLegend from '../../InputLegend';
import { InputWrapper } from '../../CustomInput/style';
import { CustomBox } from '../../../components/Tutor/style';
import {
  FiltersWrapper,
  NameWrapper,
  NamesBox,
  NamesBoxWrapper,
} from './style';
import { newForm, newFormField } from '../../../../utils/form';
import { RegexpType, validator } from '../../../../utils/validator';
import {
  ADD_NEW_GROUP,
  EDIT_GROUP,
  GROUP_USERS_GET,
  USERS_RESET,
  USER_LIST_GET,
} from '../../../../app/redux/actions/tutors';
import SortBy from '../../SortBy';
import {
  getFilterLabel,
  getNameLabel,
  getSortingOptions,
} from '../../../../utils/labels';
import CustomTooltip from '../../CustomTooltip';
import Pagination from '../../Pagination';

export const ModalGroupsId = 'ModalGroups';

const USER_TYPES_DEFAULT = [
  {
    label: 'Discente',
    value: 'consumer',
  },
  {
    label: 'Co-tutor',
    value: 'cotutor',
  },
];

// ONLY here override label.js utils
const formatFilterOpt = (opt) => {
  if (!opt) return null;
  return { label: opt?.description || opt?.value, value: opt?.key };
};

const initialForm = newForm([
  newFormField({
    field: 'title',
    required: true,
    type: RegexpType.STRING,
    valid: true,
  }),
]);

const ModalGroups = ({
  mediaIsPhone,
  mediaIsTablet,
  isOpen,
  id,
  filters,
  users,
  pager,
  payload,
  getUsers,
  modalClose,
  addNewGroup,
  editGroup,
  resetUsers,
  isSupervisor,
  group,
  getGroupUsers,
}) => {
  const scrollableAreaRef = useRef(null);
  const [groupForm, setGroupForm] = useState(initialForm);
  const [groupId, setGroupId] = useState();
  // filters
  const [showFilters, setShowFilters] = useState(true);
  const [selectedFilters, setSelectedFilters] = useState({});
  // users
  const [leftUsers, setLeftUsers] = useState([]);
  const [rightUsers, setRightUsers] = useState([]);
  // select userType
  const [userTypeOptions, setUserTypeOptions] = useState(USER_TYPES_DEFAULT);
  const [userType, setUserType] = useState('consumer');

  useEffect(() => {
    if (payload?.id) setGroupId(payload?.id);
    else setGroupId(group?.id);
  }, [group, payload]);

  useEffect(() => {
    if (groupId) setSelectedFilters({ excluded_group_ids: groupId });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupId]);

  useEffect(() => {
    if (isSupervisor) {
      setUserTypeOptions([
        ...userTypeOptions,
        {
          label: 'Tutor',
          value: 'tutor',
        },
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSupervisor]);

  useEffect(() => {
    if (id === ModalGroupsId) {
      const newGroupForm = { ...groupForm };
      if (payload?.id) {
        newGroupForm.title.value = payload?.name;
        getGroupUsers(payload.id);
      } else newGroupForm.title.value = '';
      //get filters
      getUsers({
        group_ids: -1,
      });

      setGroupForm(newGroupForm);
    }

    // if supervisor set tutor as first type (mandatory)
    if (isSupervisor) setUserType('tutor');
    return () => {
      if (id === ModalGroupsId) {
        resetUsers();
        setGroupForm(initialForm);
        // clean filters
        setSelectedFilters({});
        // clean user states
        setLeftUsers([]);
        setRightUsers([]);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, payload, isSupervisor]);

  useEffect(() => {
    setShowFilters(!mediaIsPhone);
  }, [mediaIsPhone]);

  const handleOnChange = (field = '', newValue) => {
    const { type, required } = groupForm[field];
    setGroupForm({
      ...groupForm,
      [field]: {
        ...groupForm[field],
        value: newValue,
        valid:
          typeof newValue !== 'object'
            ? validator(type, newValue, required)
            : true,
      },
    });
  };

  const handleOnChangeFilters = ({ key, value }) => {
    const newFilters = { ...selectedFilters };
    newFilters[key] = value?.value;
    setSelectedFilters(newFilters);
  };

  const startSearch = () => {
    if (!selectedFilters?.ffoo) return;
    getUsers(selectedFilters);
  };

  const handleOnChangeName = (set, uid) => {
    if (set === 'left') {
      const newUsers = [...leftUsers];
      const index = newUsers?.findIndex((u) => u === uid);
      if (index >= 0) newUsers.splice(index, 1);
      else newUsers.push(uid);
      setLeftUsers(newUsers);
    } else {
      const newUsers = [...rightUsers];
      const index = newUsers?.findIndex((u) => u === uid);
      if (index >= 0) newUsers.splice(index, 1);
      else newUsers.push(uid);
      setRightUsers(newUsers);
    }
  };

  const handleOnAddUsers = () => {
    const body = {
      name: groupForm.title?.value,
    };
    body[`${userType}s`] = leftUsers;
    editGroup(groupId, body, selectedFilters);
    setLeftUsers([]);
  };

  const handleOnRemoveUsers = () => {
    const consumers_remove = getUsersByUserType(
      group?.users,
      'consumer'
    ).filter((uId) => rightUsers?.includes(uId?.toString()));
    const tutors_remove = getUsersByUserType(group?.users, 'tutor').filter(
      (uId) => rightUsers?.includes(uId?.toString())
    );
    const cotutors_remove = getUsersByUserType(group?.users, 'cotutor').filter(
      (uId) => rightUsers?.includes(uId?.toString())
    );

    const body = {
      name: groupForm.title?.value,
      consumers_remove,
      tutors_remove,
      cotutors_remove,
    };

    editGroup(groupId, body, selectedFilters);
    setRightUsers([]);
  };

  const getUsersByUserType = (userList, role) => {
    return userList
      ?.filter((au) => au.highest_role === role)
      ?.map((u) => u?.uid);
  };

  return (
    <Modal
      title={payload?.id ? 'Modifica gruppo' : 'Crea nuovo gruppo'}
      modalId={ModalGroupsId}
      scrollableAreaRef={scrollableAreaRef}
      mbTitle={16}
    >
      <ScrollableArea ref={scrollableAreaRef} className="auto-height">
        <div className="d-flex g-24" style={{ alignItems: 'end' }}>
          <div>
            <InputLegend
              label="Titolo gruppo"
              required
              htmlFor="group-title"
              mb={4}
            />
            <InputWrapper mb={12}>
              <CustomInput
                size={mediaIsPhone ? 'full' : 'm'}
                placeholder="Inserisci"
                onChange={(newValue) => handleOnChange('title', newValue)}
                value={groupForm.title.value}
                id="group-title"
              />
            </InputWrapper>
          </div>
          {!groupId && (
            <div style={{ marginBottom: '12px' }}>
              <CTA
                btnText="Crea gruppo"
                disabled={!groupForm.title.value}
                onClick={() =>
                  addNewGroup({
                    name: groupForm.title.value,
                  })
                }
              />
            </div>
          )}
        </div>
        <CustomBox>
          {!groupId && <div className="overlay" />}
          <Text type="h2" mb={24}>
            Aggiungi utenti al gruppo{' '}
            {group?.title || payload?.name
              ? `"${group?.title || payload?.name}"`
              : ''}
          </Text>
          <FiltersWrapper className="d-flex g-24">
            <CustomInput
              size={mediaIsPhone ? 's' : 'm'}
              isSearch
              placeholder="Cerca utenti..."
              onChange={(value) =>
                handleOnChangeFilters({ key: 'search_text', value: { value } })
              }
              onClickIcon={startSearch}
              onKeyPress={(event) => {
                if (event.key === 'Enter') startSearch();
              }}
              value={selectedFilters.search_text || ''}
              icon="search-sm"
              isClearable
            />
            {mediaIsPhone && (
              <CTA
                type="secondary"
                btnText={showFilters ? 'Nascondi' : 'Filtri'}
                onClick={() => setShowFilters(!showFilters)}
                bottomRight
              />
            )}
            {showFilters && (
              <>
                {(Object.keys(filters) || [])
                  .filter((k) => k !== 'group_ids')
                  .map((key, i) => (
                    <CustomSelect
                      size={mediaIsPhone ? 'full' : 's'}
                      key={`filter-${i}`}
                      placeholder={getFilterLabel(key)}
                      options={filters[key].map((opt) => formatFilterOpt(opt))}
                      selected={
                        formatFilterOpt(
                          filters[key]?.find(
                            (f) => f?.key === selectedFilters[key]
                          )
                        ) || null
                      }
                      onChange={(value) => {
                        if (key === 'ffoo') {
                          getUsers({ group_ids: -1, ffoo: value?.value });
                          setSelectedFilters({
                            ...selectedFilters,
                            ffoo: value?.value,
                            user_work_role: null,
                          });
                        } else handleOnChangeFilters({ key, value });
                      }}
                      isClearable
                      className={key === 'ffoo' ? 'mandatory-select' : ''}
                      disabled={
                        key === 'user_work_role' && !selectedFilters.ffoo
                      }
                    />
                  ))}
              </>
            )}
            <CTA
              disabled={
                !selectedFilters.ffoo ||
                (selectedFilters?.search_text &&
                  selectedFilters?.search_text?.length < 4)
              }
              btnText="Cerca"
              onClick={() => {
                startSearch();
                if (mediaIsPhone) setShowFilters(false);
              }}
              fullsize={mediaIsPhone}
            />
          </FiltersWrapper>
          <NamesBoxWrapper>
            {/* left box */}
            <div>
              <div className={mediaIsPhone ? '' : 'd-flex sb'}>
                <Text type="b3" mb={mediaIsPhone ? 16 : 0}>
                  {pager?.total_items || 0} utenti
                </Text>
                <SortBy
                  className="light"
                  options={getSortingOptions(['alphabetical', 'ffoo'])}
                  onChange={(v) =>
                    getUsers({
                      ...selectedFilters,
                      sort_by: v?.value,
                    })
                  }
                />
              </div>
              <NamesBox>
                {users?.length > 0 ? (
                  <>
                    <NameWrapper className="select-all">
                      <Checkbox
                        label="Seleziona tutti"
                        checked={leftUsers?.length === users?.length}
                        onChange={() => {
                          if (leftUsers?.length === users?.length) {
                            setLeftUsers([]);
                          } else {
                            setLeftUsers(users.map((u) => u?.uid?.toString()));
                          }
                        }}
                      />
                      <CustomTooltip
                        type="secondary"
                        title="Attenzione"
                        tooltipKey="Puoi cambiare pagina solo dopo aver confermato la selezione"
                      />
                    </NameWrapper>
                    {users.map((u) => (
                      <NameWrapper key={u?.uid}>
                        <Checkbox
                          label={getNameLabel(u)}
                          value={u?.uid}
                          onChange={(v) => handleOnChangeName('left', v)}
                          checked={leftUsers?.includes(u?.uid?.toString())}
                        />
                      </NameWrapper>
                    ))}
                  </>
                ) : (
                  <div className="no-results">
                    Per avviare la ricerca compila i campi sopra
                  </div>
                )}
              </NamesBox>
              {pager.number_of_pages > 1 && (
                <Pagination
                  pb={16}
                  pager={pager}
                  callBack={(page) => getUsers({ ...selectedFilters, page })}
                  isDisabled={leftUsers?.length > 0}
                  hideGoToPage
                />
              )}
              <div className={mediaIsPhone ? 'mb-5' : 'd-flex'}>
                <Text type="b4">Ruolo utenti selezionati:</Text>
                <CustomSelect
                  size={mediaIsPhone ? 'full' : 's'}
                  options={userTypeOptions}
                  onChange={({ value }) => setUserType(value)}
                  selected={userTypeOptions.find(
                    (opt) => opt.value === userType
                  )}
                  disabled={isSupervisor && !group?.users?.length > 0}
                />
                {isSupervisor && (
                  <CustomTooltip
                    type="secondary"
                    title="Ruoli"
                    tooltipKey="group_tutor_mandatory"
                  />
                )}
                <CTA
                  btnText="Aggiungi"
                  icon={mediaIsPhone || mediaIsTablet ? '' : 'arrow-right'}
                  fullsize={mediaIsPhone}
                  disabled={leftUsers?.length <= 0}
                  bottomRight
                  onClick={handleOnAddUsers}
                />
              </div>
            </div>
            {/* right box */}
            <div>
              <div className={mediaIsPhone ? '' : 'd-flex sb'}>
                <Text type="b3" mb={mediaIsPhone ? 16 : 0}>
                  {group?.pager?.total_items || 0} utenti
                </Text>
                <SortBy
                  className="light"
                  options={getSortingOptions(['alphabetical', 'ffoo'])}
                  onChange={(v) =>
                    getGroupUsers(groupId, { sort_by: v?.value })
                  }
                />
              </div>
              <NamesBox>
                {group?.users?.length > 0 ? (
                  <>
                    <NameWrapper className="select-all">
                      <Checkbox
                        label="Seleziona tutti"
                        checked={rightUsers?.length === group?.users?.length}
                        onChange={() => {
                          if (rightUsers?.length === group?.users?.length) {
                            setRightUsers([]);
                          } else {
                            setRightUsers(
                              group.users.map((u) => u.uid?.toString())
                            );
                          }
                        }}
                      />
                      <CustomTooltip
                        type="secondary"
                        title="Attenzione"
                        tooltipKey="Puoi cambiare pagina solo dopo aver confermato la selezione"
                      />
                    </NameWrapper>
                    {(group?.users || []).map((u) => (
                      <NameWrapper key={u?.uid} className="d-flex sb">
                        <Checkbox
                          label={getNameLabel(u)}
                          value={u?.uid}
                          onChange={(v) => handleOnChangeName('right', v)}
                          checked={rightUsers?.includes(u?.uid?.toString())}
                        />
                        {u?.highest_role === 'consumer' ? (
                          <Text type="b4" className="consumer">
                            Discente
                          </Text>
                        ) : (
                          <Badge type="news">{u?.highest_role}</Badge>
                        )}
                      </NameWrapper>
                    ))}
                  </>
                ) : null}
              </NamesBox>
              {group?.pager?.number_of_pages > 1 && (
                <Pagination
                  pb={16}
                  pager={group.pager}
                  callBack={(page) => getGroupUsers(groupId, { page })}
                  isDisabled={rightUsers?.length > 0}
                  hideGoToPage
                />
              )}
              <CTA
                btnText="Rimuovi"
                disabled={rightUsers?.length <= 0}
                bottomRight
                fullsize={mediaIsPhone}
                onClick={handleOnRemoveUsers}
              />
            </div>
          </NamesBoxWrapper>
        </CustomBox>
      </ScrollableArea>
    </Modal>
  );
};

ModalGroups.propTypes = {
  //HOC: withMediaQueries
  mediaIsPhone: PropTypes.bool,
  mediaIsTablet: PropTypes.bool,
  // state
  filters: PropTypes.object,
  users: PropTypes.array,
  pager: PropTypes.object,
  isOpen: PropTypes.bool,
  id: PropTypes.string,
  payload: PropTypes.object,
  isSupervisor: PropTypes.bool,
  group: PropTypes.object,

  // dispatch
  modalClose: PropTypes.func.isRequired,
  getUsers: PropTypes.func.isRequired,
  addNewGroup: PropTypes.func.isRequired,
  editGroup: PropTypes.func.isRequired,
  resetUsers: PropTypes.func.isRequired,
  getGroupUsers: PropTypes.func.isRequired,
};

export default compose(
  connect(
    (state) => {
      const { filters, items: users, pager } = state.tutors.users;
      const { isOpen, id, payload } = state.app.modal;
      const { isSupervisor } = state.user;
      const { group } = state.tutors;
      return {
        filters,
        users,
        pager,
        isOpen,
        id,
        payload,
        isSupervisor,
        group,
      };
    },
    (dispatch) => ({
      modalClose: () => dispatch({ type: MODAL_CLOSE }),
      getUsers: (body, addedUsers) =>
        dispatch({ type: USER_LIST_GET._REQUEST, payload: body, addedUsers }),
      addNewGroup: (group) => dispatch({ type: ADD_NEW_GROUP._REQUEST, group }),
      editGroup: (id, payload, filters) =>
        dispatch({ type: EDIT_GROUP._REQUEST, id, payload, filters }),
      resetUsers: () => dispatch({ type: USERS_RESET }),
      getGroupUsers: (id, filters) =>
        dispatch({ type: GROUP_USERS_GET._REQUEST, id, filters }),
    })
  ),
  withMediaQueries
)(ModalGroups);
